// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"a9671185","466":"e4277a08","7261":"1169b71d","8347":"873ec13b"}[chunkId] + ".chunk.css";
};